import React from 'react';
import { Paper } from "@material-ui/core"
import SingleSound from "./SingleSound";
import { knallisounds } from "./knalliSateenvarjoClips";

export default class Soundboard extends React.Component {

    public render() {

        return (
            <Paper
                elevation={2}
                style={{ display: "flex", justifyContent: "center" }}
            >
                <Paper
                    elevation={3}
                    style={{
                        width: "80%",
                        minHeight: "20rem",
                        background: "lightgrey",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-evenly"

                    }}
                >
                    {knallisounds.map((sound, index) => {
                        return (
                            <SingleSound name={sound[1]} file={sound[0]} key={index}/>
                        );
                    })}
                </Paper>
            </Paper>
        );
    }
}